// https://keycode.info/table-of-all-keycodes

const KeyboardUtil = {
  keyCodes: {
    ARROW_DOWN: 40,
    ARROW_LEFT: 37,
    ARROW_RIGHT: 39,
    ARROW_UP: 38,
    BACKSPACE: 8,
    CLEAR: 12,
    END: 35,
    ENTER: 13,
    ESC: 27,
    HOME: 36,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    SPACE: 32,
    TAB: 9
  },
  // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
  keys: {
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_UP: 'ArrowUp',
    BACKSPACE: 'Backspace',
    CLEAR: 'Clear',
    END: 'End',
    ENTER: 'Enter',
    ESC: 'Escape',
    HOME: 'Home',
    PAGE_DOWN: 'PageDown',
    PAGE_UP: 'PageUp',
    SPACE: ' ',
    TAB: 'Tab'
  },

  getKeyCode(e) {
    return e.which || e.keyCode || 0;
  }
};

export default KeyboardUtil;
